module.exports = __webpack_public_path__ + "img/11.d8305bf4.png";